<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>{{ info.accountName }}</h1>
    </div>
    <b-card>
      <!-- <b-list-group>
        <b-list-group-item v-for="(item, index) in history" :key="index">
          <div class="history-item">
            <h5>#{{ item.id }}: Thay đổi bởi {{ item.creator.name }} - {{ formatDate(item.modifiedTime) }}</h5>
            <ul>
              <li v-for="change in compareChanges(item, index)" :key="change">{{ change }}</li>
            </ul>
          </div>
        </b-list-group-item>
      </b-list-group> -->
      <b-row class="gx-2">
        <b-col md="2">
          <MenuInner
            :activeItem="activeItem"
            :DetailMenus="DetailMenus"
            :id="id"
            :maId="id"
            :maName="info.accountName"
          >
          </MenuInner>
        </b-col>
        <b-col md="10">
          <!-- <div>
            <h3>Log Assign</h3>
            <b-table hover sticky-header responsive :items="historyAssign" :fields="fieldsAssign" :fixed="true"
              :bordered="true" :busy.sync="isLoading">
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
<template #empty>
                <div class="text-center text-info my-2">
                  Không có dữ liệu
                </div>
              </template>
<template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>
</b-table>
</div> -->
          <div>
            <h3>Lịch sử gán</h3>
            <b-table
              hover
              sticky-header
              responsive
              :items="historyConfig"
              :fields="fieldsConfig"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
              style="margin-top: 10px"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>
              <template #cell(staffAssignId)="{ item }">
                <div>
                  {{
                    `${item.staffName} - ${item.staffTypes.map(type => asignType[type]).join(', ')}`
                  }}
                </div>
                <div>
                  <span class="text-muted">Loại</span>:
                  {{ item.configType == 'MAIN' ? 'Chính' : 'Phụ' }}
                </div>
              </template>
              <template #cell(time)="{ item }">
                <div>
                  <div v-if="item.creator">
                    <span class="text-muted">Người duyệt phiếu</span>:
                    {{ item.creator?.name }}
                  </div>
                  <div v-if="item.createdTime">
                    <span class="text-muted">Thời gian duyệt phiếu</span>:
                    {{ formatDate(item.createdTime) }}
                  </div>
                </div>
              </template>
              <template #cell(creator)="{ item }">
                <div>
                  <div v-if="item.createdAssignOrderName">
                    <span class="text-muted">Người tạo phiếu</span>:
                    {{ item.createdAssignOrderName }}
                  </div>
                  <div v-if="item.createdAssignOrderDate">
                    <span class="text-muted">Thời gian tạo phiếu</span>:
                    {{ formatDate(item.createdAssignOrderDate) }}
                  </div>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { historyAssign } from '@/services/customer-support/store-staff'
  import { Detail } from '@/services/customer-support/account'
  import { showMess } from '@/config/utils'
  import MenuInner from '@/pages/customer-support/cskh/account/components/MenuInner'
  import moment from 'moment'
  import { asignType, DetailMenus } from '@/pages/customer-support/cskh/account/components/constant'

  export default {
    components: {
      MenuInner,
    },
    data() {
      return {
        isLoading: false,
        id: '',
        level: '',
        info: [],
        historyAssign: [],
        historyConfig: [],
        fieldsAssign: [],
        fieldsConfig: [
          {
            key: 'staffAssignId',
            label: 'Nhân viên chăm sóc',
            sortable: false,
            thStyle: 'width: 100px; text-align: center',
          },
          {
            key: 'creator',
            label: 'Người/Thời gian tạo phiếu gán',
            sortable: false,
            thStyle: 'width: 80px; text-align: center',
          },
          {
            key: 'time',
            label: 'Người/Thời gian duyệt phiếu gán',
            sortable: false,
            thStyle: 'width: 80px; text-align: center',
          },
        ],
        DetailMenus,
        asignType,
        activeItem: 'lich_su_gan',
      }
    },
    created() {
      this.id = this.$router.currentRoute.params.id
      this.level = 'MERCHANT_ACCOUNT'
    },

    mounted() {
      if (this.dataPermission.includes('CNPS_CSS_MA_DETAIL')) {
        this.getHistoryAssign()
        this.toggleSideBar()
        this.GetDetail()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            // size: 'sm',
            // buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(value => {
            // chuyển trang
            this.$router.replace('/')
          })
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getStaffName() {
        return staffId => {
          const uInfo = this.historyAssign[staffId] ?? undefined
          return uInfo
            ? `${uInfo.staffName} - ${uInfo.staffTypes.map(type => this.asignType[type]).join(', ')}`
            : staffId
        }
      },
    },
    methods: {
      formatDate(date, format = 'HH:mm, DD/MM/YYYY') {
        if (!date) return
        return moment(date).format(format)
      },
      toggleSideBar() {
        this.$store.commit('dom/SET_SIDEBAR_STATUS', !this.isOpen)
      },
      async getHistoryAssign() {
        try {
          this.isLoading = true
          const res = await historyAssign({
            assignmentId: this.id,
            level: this.level,
          })
          this.historyAssign = res.data.logAssigns.reduce((map, item) => {
            map[item.id] = item
            return map
          }, {})
          // console.log(this.historyAssign)
          // this.historyAssign = res.data.logAssigns;
          // this.historyConfig = res.data.logHistoryConfigs
          this.historyConfig = res.data?.logHistoryConfigs.filter(item => item.type !== 'REMOVE')

          // this.pagination.total = res.total;
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
      async GetDetail() {
        try {
          // this.isLoading = true;
          const res = await Detail(this.id)
          this.info = res.data
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          // this.isLoading = false;
        }
      },
    },
  }
</script>
<style scoped>
  .inner_menu {
    border-right: 1px solid #edf1fa;
  }

  .menu_li:hover {
    background-color: #268dfc;
    color: #fff;
    cursor: pointer;
  }

  .border-row {
    border-bottom: 2px dashed #edf1fa;
    display: flex;
  }
</style>
